import { h, Component } from 'preact'
import { connectSearchBox, SearchBoxProvided } from 'react-instantsearch/connectors'
import InputGroupWithIcons from '../../control-components/ui-components/InputGroupWithIcons'
import Icon from '../assets'
import _ from 'underscore'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props extends SearchBoxProvided {
  enableLoader: boolean
  defaultCdn: string
}

export class SearchBox extends Component<Props> {
  constructor (props: Props) {
    super(props)

    this.handleChange = _.debounce(this.handleChange.bind(this), 150)
  }

  handleChange (value: string) {
    this.props.refine(value)
  }

  render ({ defaultCdn, enableLoader, currentRefinement }: Props) {
    return (
      <Phrase p='live.search.placeholder'>
        {(placeholder: string) => {
          return (
            <div>
              <InputGroupWithIcons
                initialValue={currentRefinement}
                attributes={{
                  type: 'search',
                  placeholder: placeholder
                }}
                className=''
                preIcon={<Icon width={24} height={24} color='#6B707E' icon='search' customClass={enableLoader ? 'opacity' : ''} />}
                onChange={this.handleChange}
              />
              {
              enableLoader
                ? (
                  <span className='instant-search-loader small-loader'>
                    <img
                      src={`${defaultCdn}/images/spinner.gif`}
                      alt='loading...'
                    />
                  </span>
                  )
                : null
              }
            </div>
          )
        }}
      </Phrase>
    )
  }
}

const InstantSearchBox = connectSearchBox(SearchBox)

export default InstantSearchBox
